const img = document.createElement('img');
img.src = '/images/orange-arrow.png';

// Canvas context (ctx), current point (cp) and previous point (pp)
function drawThinningTrail(ctx, cp, pp) {
    const lifePercent = cp.percentage();
    const spreadRate = 7 * (1 - lifePercent);
    ctx.beginPath();
    ctx.moveTo(pp.x, pp.y);

    // Wider line segments for the tail so it 'chases' the fade
    ctx.lineWidth = lifePercent > 0.98 ? 2 : spreadRate;
    ctx.lineJoin = 'round';

    // As time increases decrease r and b, increase g to go from purple to green.
    const red = Math.floor(190 - 190 * lifePercent);
    const green = Math.floor(200 * lifePercent);
    const blue = Math.floor(210 - 210 * lifePercent);
    ctx.strokeStyle = `rgb(${red},${green},${blue})`;

    ctx.lineTo(cp.x, cp.y);
    ctx.stroke();
    ctx.closePath();
}

function drawPointer(ctx, { x, y }, user) {
    ctx.drawImage(
        img,
        0,
        0,
        img.naturalWidth,
        img.naturalHeight, // source rectangle
        x,
        y,
        32,
        32
    ); // destination rectangle
    ctx.font = '13px Sans-serif';
    ctx.strokeStyle = 'white';
    ctx.lineWidth = 1;
    ctx.fillStyle = 'black';
    ctx.strokeText(user, x, y + 32);
    ctx.fillText(user, x, y + 32);
}

// Calculate the rendered image rect (position + dimensions). Both canvas layers
// have to agree on where the image lands, so this lives here rather than in
// either of them.
function getImageRect(img, canvasWidth, canvasHeight) {
    if (!img) return { x: 0, y: 0, width: canvasWidth, height: canvasHeight };

    // Compare aspect ratios to determine how to fit image within canvas
    const imgAspect = img.width / img.height;
    const canvasAspect = canvasWidth / canvasHeight;

    let newWidth, newHeight;
    if (imgAspect > canvasAspect) {
        // Image is wider relative to canvas - fit to width
        newWidth = canvasWidth;
        newHeight = canvasWidth / imgAspect;
    } else {
        // Image is taller relative to canvas - fit to height
        newHeight = canvasHeight;
        newWidth = canvasHeight * imgAspect;
    }

    return {
        x: (canvasWidth - newWidth) / 2,
        y: (canvasHeight - newHeight) / 2,
        width: newWidth,
        height: newHeight
    };
}

// Size a canvas' bitmap to its parent and pin its CSS box to the parent's
// dimensions, so one bitmap pixel is pixelRatio CSS pixels - 1 by default,
// which the drawing layer's pointer maths relies on. The explicit height
// matters: with no height style the element falls back to its height
// attribute, so a stale bitmap silently clips the drawable area partway down
// the slide.
// Returns true when the bitmap dimensions changed (which clears it, so the
// caller has to redraw).
function fitCanvasToParent(canvas, pixelRatio = 1) {
    const parent = canvas && canvas.parentElement;
    if (!parent) return false;

    const width = parent.clientWidth;
    const height = parent.clientHeight;
    if (!width || !height) return false;

    canvas.style.width = `${width}px`;
    canvas.style.height = `${height}px`;

    const bitmapWidth = Math.round(width * pixelRatio);
    const bitmapHeight = Math.round(height * pixelRatio);
    if (canvas.width === bitmapWidth && canvas.height === bitmapHeight) return false;

    // Assigning either dimension wipes the bitmap.
    canvas.width = bitmapWidth;
    canvas.height = bitmapHeight;
    return true;
}

// Watch an element's size, coalescing to one callback per frame - a pane drag
// fires continuously and every re-fit reallocates a bitmap and redraws.
// Observing the container rather than the window covers the size changes a
// window 'resize' listener never sees: the chat pane divider, the mobile
// panel, fullscreen and the drawer transitions.
function observeSize(el, onResize) {
    if (!el) return () => {};

    let frame = null;
    const schedule = () => {
        if (frame !== null) return;
        frame = requestAnimationFrame(() => {
            frame = null;
            onResize();
        });
    };
    const cancel = () => {
        if (frame !== null) cancelAnimationFrame(frame);
    };

    if (typeof ResizeObserver === 'undefined') {
        // Older browsers and jsdom: a window resize is the only container
        // change left that we can still see.
        window.addEventListener('resize', schedule);
        return () => {
            cancel();
            window.removeEventListener('resize', schedule);
        };
    }

    const observer = new ResizeObserver(schedule);
    observer.observe(el);
    return () => {
        cancel();
        observer.disconnect();
    };
}

// Watch for devicePixelRatio changing - the window dragged to a screen with a
// different density, or the browser zoomed. A resolution query only matches
// one ratio, so it is re-armed for the new ratio after each change.
function observePixelRatio(onChange) {
    if (typeof window.matchMedia !== 'function') return () => {};

    let query = null;
    const arm = () => {
        query = window.matchMedia(`(resolution: ${window.devicePixelRatio || 1}dppx)`);
        query.addEventListener('change', handle, { once: true });
    };
    const handle = () => {
        arm();
        onChange();
    };
    arm();
    return () => query.removeEventListener('change', handle);
}

export { drawThinningTrail, drawPointer, getImageRect, fitCanvasToParent, observeSize, observePixelRatio };
